<template>
	<div>
		<div
			style="
				position: fixed;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				min-width: 250px;
				width: max-content;
			"
			class="scroller-container"
			id="scroller"
			v-on:keydown.down="changeSelectedIndex($event, 1)"
			v-on:keydown.up="changeSelectedIndex($event, -1)"
			v-on:keydown.enter="confirmCallback[0]"
			@keydown.escape="closeCommandEditor"
		>
			<div style="display: flex;  width: 100%; margin-top: 5px; margin-left: 5px; color: #ccc">
				<div style="width: 10%; height:auto;">
					<md-icon>help_outline</md-icon>
				</div>
				<div style=" width: 90%; height: 20px;">{{ $t("help-commands") }}</div>

			</div>

			<div class="scroller-phaser" :style="{ width: phaseLevel }" id="phase"></div>
			<div style="padding: 15px; display: flex">
				<el-input
					ref="command_input"
					:placeholder="functionPlaceholder | capitalize"
					@keydown.native.delete="deleteSearch"
					v-model="searchedText"
					prefix-icon="el-icon-search"
				></el-input>
				<el-button icon="el-icon-error" @click="closeCommandEditor" type="danger" plain></el-button>
			</div>
			<div class="popup-container" ref="scroller">
				<div v-for="(c, idx) in filtered" :key="c.index">
					<div
						class="vertical-scroller-item"
						:style="selectedIndex == idx ? 'background-color: #efefee' : 'background-color: transparent'"
						:key="c.index"
						@click="changeSelectedFunction(c, c.index)"
						v-on:keydown.enter="changeSelectedFunction(c, c.index)"
					>
						<div class="popup-image-container">
							<div style="width: 100%; height: 100%"><img :src="c.path" class="popup-image" /></div>
						</div>
						<div class="text-container">
							<div class="text-wrapper">
								<div>
									<span style="display: flex; align-items: center">{{ c.placeholder }}</span>
								</div>
							</div>
							<div class="text-description">{{ c.description }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { terminal_command } from "@/utils/terminal_command"
import { filters } from "@/utils/utils"

export default {
	name: "command-popup",
	mixins: [terminal_command, filters],
	props: ["show", "editor"],
	data() {
		return {
			phaseLevel: "0%",
			functionPlaceholder: this.$t("search"),
			searchedText: "",
			filtered: null,
			confirmCallback: [this.confirmFunction]
		}
	},
	watch: {
		show: function () {
			this.filtered = this.functions_list
			this.$nextTick(() => {
				this.$refs.command_input.focus()
				if (this.$refs.scroller.childNodes.length !== 0)
					this.$refs.scroller.childNodes[0].scrollIntoView({ behavior: "smooth" })
			})
		},
		searchedText: function (el) {
			if (el === "/") {
				this.editor.chain().focus().insertContent("/").run()
				this.closeCommandEditor(new Event("click", {}))
			}
			this.filtered = this.functions_list.filter(str =>
				str.keyword.replace(/\s+/g, "").includes(el.toLowerCase())
			)
			if (this.filtered[0]) this.changeSelectedFunction(this.filtered[0])
		}
	},
	methods: {
		closeCommandEditor(event, offset = 0) {
			// reset di tutte le variabili quando si chuide il popup
			this.$parent.actualCommand = ""
			event.preventDefault()
			this.showCommands = false
			this.searchedText = ""
			this.selectedFunction = null
			this.selectedGlob = null
			this.selectedIndex = 0
			this.phaseLevel = `0%`
			this.$parent.cmdPop = !this.$parent.cmdPop
			// this.filtered = []
			this.resetCommand()
		},
		resetCommand() {
			this.temp = []
			this.stepperIndex = 0
			this.functionPlaceholder = this.$t("write-command")
			this.confirmCallback = [this.confirmFunction]
			this.eventGlob = [this.insertGlobal]
			this.stepPhase = ""
			this.currentFunc = ""
		}
	}
}
</script>
<style scoped></style>
